export default "__VITE_ASSET__Dqfac_qC__"